import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CustomBox from '../common/CustomBox';
import useIsMobile from "../../hooks/useIsMobile";
import './MenuWidget.scss';

const MenuWidget = props => {
  const isMobile = useIsMobile();
  const combinedClassName = `MenuWidget ${props.className || ''}`.trim();

  return (
    <CustomBox
      style={props.style}
      className={combinedClassName}
      onClick={props.onClick}
    >
      <Stack className='MenuWidget__item' spacing={2} padding={1}>
        <props.Icon color='primary' sx={{ fontSize: 32 }}/>
        <Typography variant={isMobile ? 'h4' : 'h3'}>{props.title}</Typography>
      </Stack>
    </CustomBox>
  );
};

export default MenuWidget;
